"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Scale = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: scale(", ");\n"], ["\n  transform: scale(", ");\n"])), function (props) { return props.scale; });
Scale.defaultProps = {
    scale: 1
};
exports.default = Scale;
var templateObject_1;
//# sourceMappingURL=Scale.js.map